<template>
  <div class="card next-steps-component">
    <p class="font-weight-bold">Next Steps</p>
    <ul class="text-list">
      <li v-if="deniedPosts && deniedPosts.length > 0" class="list-denied-part">
        Review the feedback for parts marked as "Need Improvement"

        <div class="list-parts">
          <div
            v-for="(group, index) in groupPostsByPart(deniedPosts)"
            :key="index"
            class="group-post group__denied-post"
          >
            <strong>{{ group.name }}</strong>
            <div
              v-for="postResponse in group.posts"
              :key="postResponse.post.id"
              class="list-post-item"
            >
              {{ postResponse.post.title }}
            </div>
          </div>
        </div>
      </li>

      <li v-if="passedPosts && passedPosts.length > 0" class="list-pass-part">
        Review "Pass" parts for consistency of all evidence

        <div class="list-parts">
          <div
            v-for="(group, index) in groupPostsByPart(passedPosts)"
            :key="index"
            class="group-post group__pass-post"
          >
            <strong>{{ group.name }}</strong>
            <div
              v-for="postResponse in group.posts"
              :key="postResponse.post.id"
              class="list-post-item"
            >
              {{ postResponse.post.title }}
            </div>
          </div>
        </div>
      </li>

      <li>Make the necessary revisions and update your evidence and attachments</li>
      <li>Resubmit your work once all improvements have been addressed</li>
    </ul>

    <b-button
      variant="outline-primary"
      class="btn__update-submission"
      :disabled="loading"
      @click="$emit(emitMessage)"
    >
      {{ loading ? 'Updating...' : textButton }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'EvidenceSubmissionNextSteps',
  props: {
    deniedPosts: {
      type: Array,
      default: () => []
    },
    passedPosts: {
      type: Array,
      default: () => []
    },
    quotaEmpty: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      partTitleIndexMap: {
        OVERVIEW: 1,
        WORK_EXAMPLE: 2,
        REFLECTION: 3
      }
    };
  },
  computed: {
    groupedDeniedPosts() {
      return this.groupPostsByPart(this.deniedPosts);
    },

    groupedPassedPosts() {
      return this.groupPostsByPart(this.passedPosts);
    },

    textButton() {
      return this.quotaEmpty ? 'Buy Submission Quota' : 'Review & Edit';
    },
    emitMessage() {
      return this.quotaEmpty ? 'buy-quota' : 'update-submission';
    }
  },
  methods: {
    groupPostsByPart(posts) {
      const grouped = posts.reduce((acc, postResponse) => {
        const part = postResponse.post?.part;

        if (!part) return acc;

        if (!acc[part]) {
          acc[part] = {
            name: `Part ${this.partTitleIndexMap[part] || 0}`,
            posts: []
          };
        }
        acc[part].posts.push(postResponse);
        return acc;
      }, {});

      return Object.values(grouped);
    }
  }
};
</script>

<style lang="scss" scoped>
.next-steps-component {
  padding: 24px;

  .text-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 32px;
    padding-inline-start: 24px;
  }

  .list-parts {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 720px;
    margin-top: 12px;
  }

  .group-post {
    padding: 16px;
    border-radius: 12px;
  }

  .group__denied-post {
    background-color: #fed6da;
    color: #841e30;
    border: 1px solid #fdc6cb;
  }

  .group__pass-post {
    background-color: #cff3f8;
    color: #0c6b7e;
    border: 1px solid #bceff5;
  }

  .btn__update-submission {
    width: fit-content;
  }

  .list-denied-part::marker,
  li::marker {
    font-size: 20px;
    color: #f83245;
  }

  .list-pass-part::marker {
    font-size: 20px;
    color: #11c5db;
  }
}
</style>
